import React from 'react';

import { ReactComponent as ExternalIcon } from '../../../../assets/icons/arrow-right-top.svg';
import styles from './Externalicon.module.css';

const Externalicon = ({ size = 22 }) => {
  return <ExternalIcon className={styles.icon} style={{ '--icon-size': `${size}px` }} />;
};

export default Externalicon;
